import { create } from 'zustand';

type State = {
  masterVolume: number;
  voiceoverDurations: {
    soundId: string;
    duration: number;
  }[];
};

type Action = {
  setMasterVolume: (volume: number) => void;
  addVoiceoverDuration: (soundId: string, duration: number) => void;
};

const useAudioStore = create<State & Action>((set) => ({
  masterVolume: 1,
  voiceoverDurations: [],
  setMasterVolume: (volume) => set(() => ({ masterVolume: volume })),
  addVoiceoverDuration: (soundId, duration) =>
    set((state) => ({
      voiceoverDurations: [...state.voiceoverDurations, { soundId, duration }],
    })),
}));

export default useAudioStore;
